import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_number_input = _resolveComponent("number-input")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createBlock(_component_v_card_text, { class: "pa-0 ma-0 text-caption" }, {
    default: _withCtx(() => [
      (_ctx.type==='number')
        ? (_openBlock(), _createBlock(_component_number_input, {
            key: 0,
            "hide-details": !_ctx.errorMessage,
            "error-message": _ctx.errorMessage,
            label: _ctx.label,
            type: _ctx.subtype,
            value: _ctx.$utils.isNullOrUndefined(_ctx.valueToAdd)? undefined : Number(_ctx.valueToAdd),
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.valueToAdd = $event)),
            onKeyup: _withKeys(_ctx.onAdd, ["enter"]),
            onBlur: _cache[1] || (_cache[1] = ($event: any) => {_ctx.onAdd(); _ctx.$emit('blur', $event)})
          }, _createSlots({ _: 2 }, [
            (_ctx.canAdd)
              ? {
                  name: "append",
                  fn: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      icon: "",
                      size: "x-small",
                      onClick: _ctx.onAdd
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-plus", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["hide-details", "error-message", "label", "type", "value", "onKeyup"]))
        : (_openBlock(), _createBlock(_component_v_text_field, {
            key: 1,
            "hide-details": "",
            label: _ctx.label,
            modelValue: _ctx.valueToAdd,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.valueToAdd) = $event)),
            type: _ctx.type === 'date'? 'date':undefined,
            onKeyup: _withKeys(_ctx.onAdd, ["enter","tab"]),
            onKeydown: _withKeys(_ctx.onAdd, ["tab"]),
            onBlur: _ctx.onAdd
          }, _createSlots({ _: 2 }, [
            (_ctx.canAdd)
              ? {
                  name: "append",
                  fn: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      icon: "",
                      size: "x-small",
                      onClick: _ctx.onAdd
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("mdi-plus", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["label", "modelValue", "type", "onKeyup", "onKeydown", "onBlur"])),
      _createVNode(_component_v_chip_group, {
        column: "",
        modelValue: _ctx.selection,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selection) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_draggable, {
            modelValue: _ctx.elements,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.elements) = $event)),
            "item-key": element => element,
            onStart: _ctx.dragStart,
            onEnd: _ctx.dragEnd
          }, {
            item: _withCtx(({ element, index: i }) => [
              _createVNode(_component_v_chip, {
                size: "small",
                draggable: "",
                class: _normalizeClass({'bg-primary': i === _ctx.draggedIndex}),
                closable: "",
                "onClick:close": ($event: any) => {_ctx.elements.splice(i,1); _ctx.$emit('input', _ctx.elements)}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(element), 1)
                ]),
                _: 2
              }, 1032, ["class", "onClick:close"])
            ]),
            _: 1
          }, 8, ["modelValue", "item-key", "onStart", "onEnd"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}